import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SignInSSO from 'components/shared/SignInSSO';
import Link from 'components/shared/Link';
import Menu from 'components/shared/Menu/';

import type { Session } from 'domains/session';

import { MYBAYPHOTO_BASE_URL } from 'utils/globals';

type AccountMenuProps = {
  session: Partial<Session>;
};

function AccountMenu({ session }: AccountMenuProps) {
  function isLoggedIn(session: Partial<Session>): session is Session {
    return !!session.customer_num;
  }

  const menuItems = [
    <Link role="menuitem" type="no-style" id="my_account" href={MYBAYPHOTO_BASE_URL}>
      <FontAwesomeIcon className="signin-item-icon" icon="cog" /> My Account
    </Link>,
    <Link role="menuitem" type="no-style" id="projects_link" href="/projects">
      <FontAwesomeIcon className="signin-item-icon" icon="folder" /> My Projects
    </Link>,
    <Link role="menuitem" type="no-style" id="logout" href="/users/end_session">
      <FontAwesomeIcon className="signin-item-icon" icon="sign-out-alt" /> Log out
    </Link>,
  ];

  const menuItemsNotLoggedIn = [
    <span className="sign-in-input">
      <FontAwesomeIcon icon="sign-out-alt" className="signin-item-icon" />
      <SignInSSO text="Sign In" />
    </span>,
    <Link
      role="menuitem"
      type="no-style"
      id="get_an_account_link"
      href="https://my.bayphoto.com/users/sign_up"
    >
      <FontAwesomeIcon className="signin-item-icon" icon="user-plus" /> Get an Account
    </Link>,
  ];

  const mobileCustomerName = (
    <div className="mobile-customer-name">
      <div className="signed_in_as">Signed in as</div>
      <span>{session && session.customer_name}</span>
    </div>
  );

  return (
    <div className="signin_container">
      {isLoggedIn(session) ? (
        <React.Fragment>
          <Menu
            appearance="light"
            className="nav_link mobile-signin-menu"
            menuItems={[mobileCustomerName, ...menuItems]}
            triggerId="account-menu-trigger-mobile"
            triggerText="Open Account Menu"
            triggerIcon="user-circle"
            iconOnlyTrigger
          />
          <Menu
            className="nav_link signin-menu"
            menuItems={menuItems}
            appearance="light"
            triggerId="account-menu-trigger"
            triggerText={session.customer_name}
            position="right"
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Menu
            appearance="light"
            className="nav_link mobile-signin-menu"
            menuItems={menuItemsNotLoggedIn}
            triggerId="account-menu-trigger-mobile"
            triggerText="My Account"
            triggerIcon="user-circle"
            iconOnlyTrigger
          />
          <Menu
            className="nav_link signin-menu"
            menuItems={menuItemsNotLoggedIn}
            appearance="light"
            triggerId="account-menu-trigger"
            triggerText="My Account"
            position="right"
          />
        </React.Fragment>
      )}
    </div>
  );
}

export default AccountMenu;
